import { motion } from 'framer-motion';
import { EducationItem } from '../data/portfolioData';

interface EducationPanelProps {
  education: EducationItem[];
  certifications?: string[];
  color: string;
}

export default function EducationPanel({ education, certifications, color }: EducationPanelProps) {
  return (
    <div>
      <div className="space-y-4 mb-8">
        {education.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1, duration: 0.4 }}
            className="rounded-xl border p-5 backdrop-blur-md"
            style={{
              background: `linear-gradient(135deg, ${color}08, ${color}03)`,
              borderColor: `${color}25`,
            }}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-white font-semibold text-sm leading-tight">{item.degree}</h3>
                <p className="text-gray-400 text-xs mt-1.5">{item.institution}</p>
              </div>
              <span
                className="text-xs font-mono whitespace-nowrap mt-0.5 flex-shrink-0"
                style={{ color }}
              >
                {item.year}
              </span>
            </div>
          </motion.div>
        ))}
      </div>

      {certifications && certifications.length > 0 && (
        <div>
          <motion.h3
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-xs font-mono uppercase tracking-widest text-gray-500 mb-4"
          >
            Certifications
          </motion.h3>
          <div className="space-y-3">
            {certifications.map((cert, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -15 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + i * 0.1, duration: 0.3 }}
                className="flex gap-3 items-start"
              >
                <div
                  className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0"
                  style={{ background: color, boxShadow: `0 0 8px ${color}` }}
                />
                <p className="text-gray-400 text-xs leading-relaxed">{cert}</p>
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
